module.exports = "/_next/static/images/FreePlan-sm-5cecb2f6e9e55b3d57be8c7ce3060e1f.png";